import React from 'react';
import {useSelector} from 'react-redux';

import {analytics} from '../../services/analytics';
import {appSettingsSelector} from '../redux/slices/appSettingsSlice';

export const useAnalyticsDataCollection = () => {
  const {agreeAgreement} = useSelector(appSettingsSelector);

  React.useEffect(() => analytics.setEnabled(agreeAgreement), [agreeAgreement]);
};
